import { render, staticRenderFns } from "./firstVisit.vue?vue&type=template&id=1ff26386&scoped=true&"
import script from "./firstVisit.vue?vue&type=script&lang=tsx&"
export * from "./firstVisit.vue?vue&type=script&lang=tsx&"
import style0 from "./firstVisit.vue?vue&type=style&index=0&id=1ff26386&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff26386",
  null
  
)

export default component.exports